// List of routes that are accessible without authentication
const allowedAuthRoutes = [
  '/auth/login',
  '/auth/access-denied'
];

const publicRoutes = [
  '/public/apartment',
]

export const isAuthPath = (path: string): boolean => {
  return allowedAuthRoutes.some(route => path.startsWith(route));
};

export const isPublicPath = (path: string): boolean => {
  return publicRoutes.some(route => path.startsWith(route));
};
